export enum Roles {
    administrator = 'Admin',
    clerk = 'Clerk',
}
